var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"d-flex align-center"},[_c('button-router'),_c('history'),_c('search',{staticClass:"mx-6"}),_c('avatar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }